import { render } from "./CommunityCard.vue?vue&type=template&id=12696696&ts=true"
import script from "./CommunityCard.vue?vue&type=script&lang=ts"
export * from "./CommunityCard.vue?vue&type=script&lang=ts"

import "./CommunityCard.vue?vue&type=style&index=0&id=12696696&scope=true&lang=css"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__